export const BASE_API_URL = import.meta.env.VITE_API_BASE_URL || ''

export const PORTAL_HEADER_KEY = { 'X-PLATFORM-KEY': 'LoanDocPlatform' }

export const VALIDATE_SESSION_API = `${BASE_API_URL}/users/authenticate`

export const SEND_OTP_API = `${BASE_API_URL}/users/otp`
export const VERIFY_OTP_API = `${BASE_API_URL}/users/login`
export const LOGOUT_API = `${BASE_API_URL}/users/logout`

// Documents
export const DOCUMENTS_API = `${BASE_API_URL}/users/loan-docs-info`

// Profile
export const PROFILE_API = `${BASE_API_URL}/users/profile`

// Dashboard
export const DASHBOARD_API = `${BASE_API_URL}/users/repayment-dashboard`

// Loan Detail
export const LOAN_DETAIL_API = `${BASE_API_URL}/users/loan-details`

// History
export const HISTORY_API = `${BASE_API_URL}/users/repayment-history`

// EMI Schedule
export const EMI_SCHEDULE_API = `${BASE_API_URL}/users/emi-schedule`

// Pay
export const PAY_API = `${BASE_API_URL}/users/loan-payment`
export const TRANSACT_API = `${BASE_API_URL}/users/payment-transact`
